import {
  GET_CLUB_REQUEST,
  LIST_CLUBS_REQUEST,
  LIST_CLUBS_SUCCESS_GTM,
  CLUB_CLICK_SUCCESS_GTM
} from './constants';

export const listClubs = (isIncludeGTM = false) => ({
  type: LIST_CLUBS_REQUEST,
  isIncludeGTM
});

export const getClub = (slug) => ({ type: GET_CLUB_REQUEST, slug });

export const clubJoinGTM = (payload) => ({
  type: LIST_CLUBS_SUCCESS_GTM,
  payload,
  viewType: 'joinButton'
});

export const clubClick = (payload) => ({
  type: CLUB_CLICK_SUCCESS_GTM,
  payload
});
